import React, { useState } from "react";
import "../../pages/reported-issue-details.css";
import { CATEGORY_ID_MAP } from "../../assets/constant";
import axios from "axios";
import { BASE_URL } from "../../assets/constant";

const CommentForm = ({ user, updateComment }) => {
  const [comment, setComment] = useState("");
  const [attachment, setAttachment] = useState(null);

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleAttachmentChange = (e) => {
    setAttachment(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const [type, recallId, issueId] = window.location.href.split("/").slice(-3);
    try {
      const formData = new FormData();
      formData.append("comment", comment);
      formData.append("CommentsAttach", attachment);
      formData.append("issue_id", issueId);
      formData.append("recallid", recallId);
      formData.append("category", CATEGORY_ID_MAP[type]);
      formData.append("username", user?.user?.fname + " " + user?.user?.lname);

      const response = await axios.post(
        `${BASE_URL}/recall/savecomments`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`
          }
        }
      );
      updateComment(response?.data?.commentsData);
      // Reset form
      setComment("");
      setAttachment(null);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form className="comment-form" onSubmit={handleSubmit}>
      <h3>Comments</h3>
      <div className="comment-input-container">
        <div className="profile-icon">
          <i className="fa fa-user"></i>
        </div>
        <input
          type="text"
          className="comment-input"
          placeholder="Enter your comment"
          value={comment}
          onChange={handleCommentChange}
          required
        />
        <button type="submit" className="send-button">
          <i className="fa fa-paper-plane"></i>
        </button>
      </div>
      <div className="attachment-container">
        <label htmlFor="attachment" className="attachment-label">
          <i className="fa fa-paperclip"></i> Add Attachments
        </label>
        <input
          id="attachment"
          type="file"
          className="attachment-input"
          onChange={handleAttachmentChange}
        />
        {attachment && (
          <div className="attachment-preview">
            <span className="attachment-name">{attachment.name}</span>
            <i
              className="fa-solid fa-circle-xmark remove-attachment-button"
              onClick={() => setAttachment(null)}></i>
          </div>
        )}
      </div>
    </form>
  );
};

export default CommentForm;
